import { normalize } from '@dtvgo/typed-normalizr';
import { ShowEntity, SeasonEntity } from '../../utils/normalizr/entities.js';
import '../../utils/normalizr/interfaces.js';
import 'lodash/set';
import 'lodash/sortBy';
import 'lodash/mapKeys';
import 'lodash/defaultsDeep';
import '@dtvgo/constants';
import '../../utils/normalizr/constants.js';
import 'query-string';
import '../../utils/normalizr/utils.js';

function shows(backendAxiosInstance) {
  async function getShowDetail(showId, params) {
    const response = await backendAxiosInstance.get(`/contents/v1/shows/${showId}`, {
      includeLanguage: true,
      params
    });
    response.normalizedData = normalize({
      ...response.data,
      vrioAssetId: response.data.vrioAssetId || showId
    }, ShowEntity);
    return response;
  }
  async function getSeasonDetail(showId, seasonNumber, params) {
    const response = await backendAxiosInstance.get(`/contents/v1/shows/${showId}/seasons/${seasonNumber}`, {
      includeLanguage: true,
      params
    });
    response.normalizedData = normalize(response.data, SeasonEntity);
    return response;
  }
  return {
    getShowDetail,
    getSeasonDetail
  };
}

export { shows as default };
//# sourceMappingURL=shows.js.map
